module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/log.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-opener-title-toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01"
    }
  }, [_vm._v("EQUIPMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02"
    }
  }, [_vm._v("TECHNIQUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BURGERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEEF")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PORK")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHICKEN, TURKEY & OTHER BIRDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FISH & SHELLFISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VEGETABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIZZA")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DESSERT")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRINES, RUBS & SAUCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter_opener_toc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0